import * as React from "react";
import { Grid, Stack, Typography } from "@mui/material";
import Accordion from "../Accordion";
import DialplanNode from "./DialplanNode";
import TtsAnnounce from "./TtsAnnounce";
import { DEFAULT_WEBHOOK_REQUEST, WebhookConfiguration } from "./Webhook";

function WebhookRoutingNode() {
  const [openAccordion, setOpenAccordion] = React.useState(false);

  return (
    <Grid container direction="column">
      <Grid item xs={12}>
        <WebhookConfiguration
          title="Instradamento tramite webhook"
          description="La risposta del servizio esterno decide quale ramo del dialplan eseguire. Qualunque risposta HTTP 2xx seleziona il ramo di successo."
        />
      </Grid>

      <Grid item xs={12} sx={{ mt: 2 }}>
        <Typography variant="body2" color="text.secondary">
          Status non-2xx, timeout ed errori di rete selezionano il ramo alternativo.
        </Typography>
      </Grid>

      <Grid item container sx={{ mt: 4 }}>
        <Stack spacing={2} width="100%">
          <Accordion
            title="✅"
            description="Risposta HTTP 2xx"
            expanded={openAccordion === "success"}
            onChange={() => setOpenAccordion(openAccordion === "success" ? false : "success")}
          >
            <DialplanNode prop="success" />
          </Accordion>

          <Accordion
            title="🟥"
            description="Errore HTTP, timeout o servizio non raggiungibile"
            expanded={openAccordion === "failure"}
            onChange={() => setOpenAccordion(openAccordion === "failure" ? false : "failure")}
          >
            <DialplanNode prop="failure" />
          </Accordion>
        </Stack>
      </Grid>
    </Grid>
  );
}

WebhookRoutingNode.description = "Instrada la chiamata in base all'esito di una richiesta HTTP sincrona.";
WebhookRoutingNode.title = "Instradamento tramite webhook";
WebhookRoutingNode.default = {
  type: "WEBHOOK_ROUTING",
  ...DEFAULT_WEBHOOK_REQUEST,
  headers: { ...DEFAULT_WEBHOOK_REQUEST.headers },
  success: {
    ...TtsAnnounce.default,
    text: "La richiesta è stata autorizzata."
  },
  failure: {
    ...TtsAnnounce.default,
    text: "La richiesta non è stata autorizzata."
  }
};
WebhookRoutingNode.isAdvanced = true;

export default WebhookRoutingNode;
